<template>
  <div>
    <client-only>
      <UiAlert v-if="showAlert" :alert="alertData" :auto-close="true" />
    </client-only>

    <HeroSection />
    <OnetoOne />
    <InfoSection />
    <CardSection />
    <AcademyVideo />
    <StatsSection />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useSupabaseClient, useRoute } from "#imports";
import HeroSection from "@/components/HeroSection.vue";
import OnetoOne from "~/components/OnetoOne.vue";
import InfoSection from "@/components/InfoSection.vue";
import CardSection from "@/components/CardSection.vue";
import AcademyVideo from "@/components/AcademyVideo.vue";
import StatsSection from "@/components/StatsSection.vue";
import UiAlert from "@/components/ui/UiAlert.vue";
import { useI18n } from "vue-i18n";

const { t, locale } = useI18n();

const supabase = useSupabaseClient();

console.log("ACTIVE LOCALE", locale.value);

const route = useRoute();

const showAlert = ref(false);
const alertData = ref({});

onMounted(async () => {
  if (!import.meta.client) return;

  const code = route.query.code as string;
  const type = route.query.type as string;

  if (code && type === "signup") {
    const { error } = await supabase.auth.verifyOtp({
      type: "signup",
      token: code,
    });

    if (!error) {
      alertData.value = {
        type: "success",
        title: t("alerts.verify_success"),
        description: t("alerts.verify_success"),
      };
      showAlert.value = true;
      setTimeout(() => {
        navigateTo("/");
      }, 3000);
    } else {
      alertData.value = {
        type: "error",
        title: t("alerts.verify_failed"),
        description: error.message,
      };
      showAlert.value = true;
    }
  }
});
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Sora:wght@400;600&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Fira+Sans:wght@300&display=swap");

.font-fira {
  font-family: "Fira Sans", sans-serif;
}
</style>
